import Vue from "vue";
import Vuex from "vuex";
import service from '../../services/tablas/tables';


Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    tables: [],
  },

  mutations: {
   
    setTables(state, data) {
      state.tables= data;
    },
  
  },
  actions: {

    async getTables(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getTables();
          state.commit("setTables", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
   

}
});
